import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { capitalize } from '@winelidays/wld-tsx-2/utils';
import FiltersSummaryLine from './FiltersSummaryLine';
const TimeContent = (t0) => {
    const $ = _c(5);
    const { time, completion } = t0;
    const translate = useTranslate();
    let t1;
    if ($[0] !== translate) {
        t1 = capitalize(translate("messages.time", { count: 1 }));
        $[0] = translate;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    const label = t1;
    const value = completion !== true && !completion.time || !time || !time.eventTime ?
        "-" :
        time.eventTime.time;
    let t2;
    if ($[2] !== label || $[3] !== value) {
        t2 = <FiltersSummaryLine label={label} value={value}/>;
        $[2] = label;
        $[3] = value;
        $[4] = t2;
    }
    else {
        t2 = $[4];
    }
    return t2;
};
export default TimeContent;
